// ====================================
// src/pages/errors/NotFound.jsx
// ====================================
import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getDefaultRoute } from '../../utils/routeUtils';
import { ROUTES } from '../../utils/constants';

const NotFound = () => {
  const navigate = useNavigate();
  const { role, isAuthenticated } = useSelector((state) => state.auth);

  const handleGoHome = () => {
    if (isAuthenticated && role) {
      const defaultRoute = getDefaultRoute(role);
      navigate(defaultRoute);
    } else {
      navigate(ROUTES.LOGIN);
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        textAlign="center"
        gap={3}
      >
        <Typography 
          variant="h1" 
          component="h1" 
          sx={{ 
            fontSize: { xs: '4rem', md: '6rem' },
            fontWeight: 'bold',
            color: 'primary.main'
          }}
        >
          404
        </Typography>
        
        <Typography 
          variant="h4" 
          component="h2" 
          gutterBottom
          sx={{ 
            fontSize: { xs: '1.5rem', md: '2rem' },
            mb: 2
          }}
        >
          Page Not Found
        </Typography>
        
        <Typography 
          variant="body1" 
          color="text.secondary"
          sx={{ 
            mb: 4,
            maxWidth: '500px',
            fontSize: '1.1rem'
          }}
        >
          The page you are looking for might have been removed, had its name changed, 
          or is temporarily unavailable.
        </Typography>
        
        <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleGoHome}
            size="large"
          >
            {isAuthenticated ? 'Go to Dashboard' : 'Go to Login'}
          </Button>
          
          <Button 
            variant="outlined" 
            onClick={handleGoBack}
            size="large"
          >
            Go Back
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NotFound;